<app-element-loader [loadingMessage]="loadingMessage" [loadingStatus]="loadingStatus"></app-element-loader>
<div class="modal-header modal-custom__header modal__airport-header">
  <h4 class="modal-title" id="modal-basic-title"><i class="icon-pin"></i> Da dove parti?<br /><small
      *ngIf="this.isB2B">Puoi selezionare fino a 3 punti di partenza</small></h4>
  <div class="modal__airport-header__buttons">
    <button type="button" class="btn btn--blue-outline btn--uppercase btn--font-normal btn--border-thick"
      (click)="modal.dismiss()">
      Chiudi <i class="icon-close"></i>
    </button>
    <button type="button" class="btn btn--zeus btn--uppercase btn--font-normal"
      [class.disabled]="!selectedAirportInner || (selectedAirportInner && selectedAirportInner.length === 0)"
      (click)="this.confirmSelectedAirports(this.selectedAirportInner, true, true)"
      [disabled]="!selectedAirportInner || (selectedAirportInner && selectedAirportInner.length === 0)">
      Conferma <i class="icon-chevron-right"></i>
    </button>
  </div>
</div>

<div class="modal-body modal-custom__body modal__airport-body">
  <div class="destinations-airport">
    <div class="destinations-container">
      <div class="destinations-airport__container-title mb-2">
        <h5 *ngIf="(groupedAiports$ | async)?.specialAirports?.length">Solo Soggiorno</h5>
      </div>
      <div class="destinations-airport__container justify-content-start"
        *ngIf="(groupedAiports$ | async)?.specialAirports?.length">
        <div class="destinations-airport__column"
          *ngFor="let specialAirport of (groupedAiports$ | async)?.specialAirports">
          <ul class="destinations-airport__content">
            <li class="destinations-airport__element mt-0"
                [class.active]="hasSelectedAirport(specialAirport.Id)"
                [class.disabled]="hasSelectedAllAirports() || hasSelectedAirportOrHarbour()"
              (click)="toggleAirport(specialAirport.Id)">
              <i class="g-icon-hotel"></i> {{specialAirport.Name}}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Porti -->
    <div class="destinations-container">
      <div class="destinations-airport__container-title">
        <h5 *ngIf="(groupedAiports$ | async)?.specialHarbours?.length">Porti</h5>
      </div>
      <div class="destinations-airport__container justify-content-start"
        *ngIf="(groupedAiports$ | async)?.specialHarbours.length > 0">
        <div class="destinations-airport__column"
          *ngFor="let specialHarbour of (groupedAiports$ | async)?.specialHarbours">
          <ul class="destinations-airport__content">
            <li class="destinations-airport__element mt-0"
                [class.active]="hasSelectedAirport(specialHarbour.Id)"
                [class.disabled]="hasSelectedOnlyLand()"
              (click)="toggleAirport(specialHarbour.Id)">
              <i class="g-icon-ship"></i> {{specialHarbour.Name}}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Bus -->
    <div class="destinations-container">
      <div class="destinations-airport__container-title">
        <h5 *ngIf="(groupedAiports$ | async)?.specialBusses?.length">Bus</h5>
      </div>
      <div class="destinations-airport__container justify-content-start"
        *ngIf="(groupedAiports$ | async)?.specialBusses?.length">
        <div class="destinations-airport__column"
          *ngFor="let specialBus of (groupedAiports$ | async)?.specialBusses">
          <ul class="destinations-airport__content">
            <li class="destinations-airport__element mt-0"
                [class.active]="hasSelectedAirport(specialBus.Id)"
                [class.disabled]="hasSelectedOnlyLand()"
              (click)="toggleAirport(specialBus.Id)">
              <i class="g-icon-bus-filled"></i> {{specialBus.Name}}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Aeroporti -->
    <div class="destinations-container">
      <div class="destinations-airport__container-title mb-2">
        <h5 *ngIf="(groupedAiports$ | async)?.groups?.length">Aeroporti</h5>
      </div>
      <ul *ngIf="(groupedAiports$ | async)?.groups?.length"
          class="destinations-airport__container  destinations-airport__content">
        <li class="destinations-airport__element mt-0"
            [class.active]="hasSelectedAirport(allAirportsGenericId)"
            [class.disabled]="hasSelectedOnlyLand() || hasSelectedOnlyAirport()"
          (click)="toggleAirport(allAirportsGenericId)">
          <i class="icon-airplane"></i> Tutti gli aeroporti
        </li>
      </ul>
      <div *ngIf="(groupedAiports$ | async)?.groups?.length"
           class="destinations-airport__container">
        <div class="destinations-airport__column" *ngFor="let airportsGroup of (groupedAiports$ | async)?.groups">
          <h5 class="destinations-airport__title">{{airportsGroup.name}}</h5>
          <ul class="destinations-airport__content">
            <li class="destinations-airport__element"
                (click)="toggleAirport(airport.Id)"
                [class.active]="hasSelectedAirport(airport.Id)"
                [class.disabled]="hasSelectedAllAirports() || hasSelectedOnlyLand()"
                *ngFor="let airport of airportsGroup.airports">
              <i class="icon-airplane"></i> {{airport.Name}} ({{airport.Code}})
              <i class="g-icon-close-circle destinations-airport__element--close"
                *ngIf="this.isB2B && hasSelectedAirport(airport.Id)"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="destinations-container">
      <div class="destinations-airport__container"
           *ngIf="(airportsPrefetch$ | async)?.length === 0">
        Nessuna partenza disponibile
      </div>
    </div>
  </div>

</div>